import React from 'react';
import { Link, useMatch } from 'react-router-dom';

import { Icon } from '../../components';
import { ListItemWrapper } from './AttachedDocs.styled';

const ListItem = ({ item }) => {
  const match = useMatch();

  return (
    <Link
      to={`${match.pathname}?attachment=${item.id}&type=${
        item.mediaType.split('/')[1]
      }&title=${item.title}`}
    >
      <ListItemWrapper>
        <Icon title={item.mediaType} />
        <span>{item.title}</span>
      </ListItemWrapper>
    </Link>
  );
};

export default ListItem;
